import EmblaCarousel from 'embla-carousel'

class ImageSlider extends HTMLElement {
  constructor () {
    super()

    this.state = {}
    this.imageSlider = this.querySelector('.grid-wrapper');
    this.controls = this.querySelector('.slider-controls');

    this.handleSlideFocusIn = this.handleSlideFocusIn.bind(this)
    this.resetScrollPosition = this.resetScrollPosition.bind(this)
    this.setup = this.setup.bind(this)
    this.teardown = this.teardown.bind(this)
    this.prev = this.controls.querySelector('.prev');
    this.next = this.controls.querySelector('.next');

    this.setup()

    this.parentElement.parentElement.addEventListener('shopify:section:unload', () => {
      this.teardown()
    })
    this.parentElement.parentElement.addEventListener('shopify:section:load', () => {
      this.setup()
    })
    this.parentElement.parentElement.addEventListener('shopify:block:select', (event) => {
      console.log({ event, index: [...event.target.parentElement.children].indexOf(event.target) })
      this.embla.scrollTo([...event.target.parentElement.children].indexOf(event.target))
    })
  }

  setup () {
    if (this.imageSlider.querySelectorAll('.slide-image').length <= 1) {
      return
    }

    const options = {
        loop: false,
        align: 'start',
        breakpoints: {
            '(min-width: 990px)': { active: false }
        }
    };
    
    
    this.embla = EmblaCarousel(this.imageSlider, options)
   
    //this.embla.on('select', this.updateSliders.bind(this));
    this.prev.addEventListener('click', this.embla.scrollPrev, false);
    this.next.addEventListener('click', this.embla.scrollNext, false);

    // Lock horizontal scroll for parent element
    this.parentElement.addEventListener('scroll', this.resetScrollPosition)

    // Jump to focused slide when moving with keyboard
   // this.addEventListener('focusin', this.handleSlideFocusIn)

    if (this.state.selectedScrollSnap) {
      this.embla.scrollTo(this.state.selectedScrollSnap)
    }
  }

  teardown () {
    if (this.embla) {
      this.state.selectedScrollSnap = this.embla.selectedScrollSnap
      this.embla.destroy()
      this.parentElement.removeEventListener('scroll', this.handleSlideFocusIn)
      this.removeEventListener('focusin', this.handleSlideFocusIn)
    }
  }

  resetScrollPosition () {
    this.parentElement.scrollTo(0, 0)
  }

  handleSlideFocusIn (event) {
    const slide = event.target.closest('.slide-image')
    const slideIndex = parseInt(slide.getAttribute('data-slide-index'), 10) - 1

    this.embla.scrollTo(slideIndex, true)
  }

  updateSliders () {
        
    const newIndex = this.embla.selectedScrollSnap();
    const newCtnSlide = this.contentSlides.item(newIndex);

    this.state.activeContent.classList.remove('active');
    newCtnSlide.classList.add('active');

    this.counters.forEach( ctr => ctr.innerText = newIndex + 1);
    this.state.activeContent = newCtnSlide;

  }

}

customElements.define('image-slider', ImageSlider)
